import { css } from '@emotion/react';

import { fontFamily, lineHeight } from '@/styles/font';

/** Pretendard 기반 전역 타이포그래피 */
export const typographyGlobal = css`
	:root {
		--font-sans: ${fontFamily.sans};
		--lh-display: ${lineHeight.tight};
		--lh-heading: ${lineHeight.snug};
		--lh-body: ${lineHeight.relaxed};
		--lh-ui: ${lineHeight.normal};
	}

	html {
		font-family: var(--font-sans);
	}

	body {
		font-family: var(--font-sans);
		letter-spacing: -0.02em;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-family: inherit;
		font-weight: inherit;
		line-height: var(--lh-heading);
		letter-spacing: -0.03em;
		word-break: keep-all;
	}

	p,
	li,
	dd,
	dt {
		line-height: var(--lh-body);
	}

	button,
	input,
	textarea,
	select,
	option {
		font-family: inherit;
		font-size: inherit;
		letter-spacing: inherit;
	}

	table {
		font-family: inherit;
	}

	strong,
	b {
		font-weight: 600;
	}

	small {
		font-size: 0.875em;
		line-height: var(--lh-ui);
	}
`;
